module.exports = __webpack_public_path__ + "img/icon4.3a27f4ed.svg";